export default __webpack_public_path__ + "static/media/backgroundeSalarium.9ba7f7cf.png";